import { ReactNode } from 'react';
import DadosCadastraisParaTipoResponsavel from './DadosCadastraisParaTipoResponsavel';
import DadosCadastraisParaTipoEscola from './DadosCadastraisParaTipoEscola';

export const DadosCadastrais = (props: {children: ReactNode}) => {
    return (
        <div style={{ margin: "1em", height: "100%" }}>
            {props.children}
        </div>
    );
};

DadosCadastrais.ParaTipoResponsavel = DadosCadastraisParaTipoResponsavel;
DadosCadastrais.ParaTipoEscola = DadosCadastraisParaTipoEscola;